<template>
<div v-if="expanded">
    <button @click.prevent="allow" class="font-bold text-primary mx-2" title="Deliver Always..." :class="disabled ? 'opacity-50 cursor-default' : ''" :disabled="disabled"><font-awesome-icon :icon="['far', 'thumbs-up']" class="mr-1"></font-awesome-icon><span class="hidden md:inline">Deliver Always...</span></button>
    <button @click.prevent="deny" class="font-bold text-destructive mx-2" title="Block..." :class="disabled ? 'opacity-50 cursor-default' : ''" :disabled="disabled"><font-awesome-icon :icon="['far', 'thumbs-down']" class="mr-1"></font-awesome-icon><span class="hidden md:inline">Block...</span></button>
</div>
<div v-else>
    <div class="hidden xl:block">
        <!-- <button @click.prevent="allow" class="font-bold text-primary px-1">Unzap</button> -->
        <button @click.prevent="allow" class="font-bold text-primary px-1" title="Deliver Always..." :class="disabled ? 'opacity-50 cursor-default' : ''" :disabled="disabled"><font-awesome-icon :icon="['far', 'thumbs-up']"></font-awesome-icon> <span class="hidden md:inline">Deliver Always...</span></button>
        <button @click.prevent="deny" class="font-bold text-destructive px-1" title="Block..." :class="disabled ? 'opacity-50 cursor-default' : ''" :disabled="disabled"><font-awesome-icon :icon="['far', 'thumbs-down']"></font-awesome-icon> <span class="hidden md:inline">Block...</span></button>
        <!-- <button @click.prevent="immediately" class="font-bold text-primary">Deliver Immediately</button> -->
        <!-- <button @click.prevent="deny" class="font-bold text-destructive px-1">Keep Zapping</button> -->
    </div>
    <div class="relative block xl:hidden">
        <button class="rounded-full overflow-hidden text-primary" @click.prevent="toggle">
            <font-awesome-icon :icon="['fas', 'ellipsis-h']"></font-awesome-icon>
        </button>
        <button v-if="isOpen" @click.prevent="toggle" tabindex="-1" class="fixed inset-0 h-full w-full cursor-default"></button>
        <div class="block absolute right-0 top-full border border-gray-dark py-2 w-48 bg-white rounded-lg shadow-xl z-20" :class="isOpen ? '' : 'hidden'">
            <button @click.prevent="allow" class="block w-full text-left px-4 py-2 text-primary font-bold hover:bg-primary hover:text-white" :class="disabled ? 'opacity-50 cursor-default' : ''" :disabled="disabled"><font-awesome-icon :icon="['far', 'thumbs-up']"></font-awesome-icon> Deliver Always...</button>
            <!-- <button @click.prevent="immediately" class="block w-full text-left px-4 py-2 hover:bg-primary hover:text-white">Delivery Immediately</button> -->
            <button @click.prevent="deny" class="block w-full text-left px-4 py-2 text-destructive font-bold hover:bg-destructive hover:text-white" :class="disabled ? 'opacity-50 cursor-default' : ''" :disabled="disabled"><font-awesome-icon :icon="['far', 'thumbs-down']"></font-awesome-icon> Block...</button>
        </div>
    </div>
</div>
</template>

<script>
import ActionConfirmationModal from './ActionConfirmationModal';

export default {
    props: {
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        expanded: {
            type: Boolean,
            required: false,
            default: false,
        },
        messages: {
            type: Array,
            required: true,
        }
    },
    data() {
        return {
            isOpen: false,
        }
    },
    methods: {
        closeHoverMenu() {
            this.isOpen = false;
        },
        toggle() {
            this.isOpen = !this.isOpen;
        },
        immediately() {
            return this.inspect('immediate');
        },
        deny() {
            return this.inspect('deny');
        },
        allow() {
            return this.inspect('allow');
        },
        inspect(action) {
            this.closeHoverMenu();
            Modal.show(ActionConfirmationModal, {propsData: {
                action : action,
                messages: this.messages,
            }}).then(response => {
                this.$emit('inspected', {
                    'action': action,
                    'type'  : response.type,
                })
            }).catch(err => {console.error(err)});
        }
    }
}
</script>